module.exports = __webpack_public_path__ + "img/star-project.59fdb5ba.jpg";